import defaultTheme from 'core/themes/serenity/serenityDefault'
import { ThemeConfig } from './model'
import { path } from 'ramda'

export const componentUpdaterObject = (themePath, value) => {
  return {
    pathTo: themePath,
    value: value || path(['components', ...themePath], defaultTheme),
  }
}

export const generateThemeUpdatePayload = ({ headerColor, sidenavColor }: ThemeConfig) => {
  return {
    components: [
      componentUpdaterObject(['header', 'background'], headerColor),
      componentUpdaterObject(['sidebar', 'background'], sidenavColor),
    ],
  }
}
